/**
 * The communication languages the apps ship translations for. Mirrors the
 * `users.language` enum in the API and the `public/locales/<lng>/` folders in
 * the web and admin apps.
 *
 * Translation folders are named by base language only (`sv`, never `sv-SE`), so
 * any i18next instance using the HTTP backend must pass this list as
 * `supportedLngs` together with `load: "languageOnly"`. Without both, a browser
 * reporting a regional tag makes i18next fetch `/locales/sv-SE/*.json` and every
 * namespace 404s (PLA-463).
 */
export const SUPPORTED_LANGUAGES = ["en", "fi", "sv"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Normalize an i18next language tag (`fi`, `fi-FI`, `en-GB`, `sv-SE`) to a
 * supported language. Unknown tags fall back to English.
 */
export const toSupportedLanguage = (
	tag: string | null | undefined,
): SupportedLanguage => {
	const base = tag?.toLowerCase().split("-")[0];
	return (
		SUPPORTED_LANGUAGES.find((language) => language === base) ??
		SUPPORTED_LANGUAGES[0]
	);
};
